




































import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import { useConfig } from '~/composables';
import { getTagColor } from '~/utils/solepro/products';
import { ProductBox } from '~/utils/types/Product';
export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductBox>,
            required: true
        },
        classes: {
            type: Object,
            default: ()=>{ return {}}
        },
        trackCard: {
            type: Function
        },
        hideBoxDescription:{
            default:false
        }
    },
    data(){
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    setup(props) {
        const {config} = useConfig();
        const storeCode = config.value.store_code;
        const trackCardEvent = async () => {
            if(props.trackCard){
                await props.trackCard(props.product.name)
            }
            location.href = `/${storeCode}/${props.product.url_key + props.product.url_suffix}`;
            
        }
        return {
            getTagColor,
            trackCardEvent,
            storeCode,
            topics: props.product.topics.slice(0,2)
        }
    }
})
